import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { ReporteEficienciaRADParams, ReporteEficienciaRADPForm } from "./form";


type Entity = ReporteEficienciaRADParams;

interface State {
    value: Entity;
}
export class ReporteEficienciaRAD extends React.PureComponent<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onGenerar = async () => {
        const value = await this.state.value;
        var reporte = await resources.BitacoraRAD.GetReporte(value.min, value.max);
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Eficiencia de RAD.xls");
    }

    render() {
        return <ReporteEficienciaRADPForm
            value={this.state.value}
            onChange={this.onChange}
            onGenerar={this.onGenerar}
        />;
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/reporte/index.tsx